import $ from "$";
import React, { Component } from "react";
import { Tree, Row, Col, message, Spin } from "antd";
import WeaInputSearch from "../wea-input-search";
import WeaNewScroll from "../wea-new-scroll";
// import WeaScroll from '../wea-scroll';
import isArray from "lodash/isArray";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import middleware from "../../middleware";
import WeaLocaleProvider from "../wea-locale-provider";
import WeaTreeTest from "../wea-tree-test";

const getLabel = WeaLocaleProvider.getLabel;
const TreeNode = Tree.TreeNode;

function objToArray(obj) {
  if (!isArray(obj)) {
    let arr = [];
    arr.push(obj);
    obj = arr;
  }
  return obj;
}

const getKeys = (datas, itemMainKey = "domid") => {
  datas = objToArray(datas);
  return datas.map(data => data[itemMainKey]);
};

// 获取总数，和每一叉树的所有 key
const getAllKeys = (datas, itemMainKey = "domid") => {
  datas = objToArray(datas);
  let num = datas.length;
  let keys = getKeys(datas, itemMainKey);
  const childs = datas.map(data => {
    const obj = {
      [itemMainKey]: data[itemMainKey],
      childs: [],
      keys: []
    };
    if (data.childs && data.childs.length > 0) {
      const _obj = getAllKeys(data.childs);
      num += _obj.num;
      obj.num = _obj.num;
      obj.childs = [..._obj.childs];
      obj.keys = [..._obj.keys];
      keys = keys.concat(_obj.keys);
    }
    return obj;
  });
  return {
    num,
    childs,
    keys
  };
};

// 添加节点是否可展开标识，即是否有子集
const addLeaf = datas => {
  datas = objToArray(datas);
  return datas.map(data => {
    const _data = { ...data };
    if ("isLeaf" in data) return _data;
    if (data.childs && data.childs.length > 0) {
      _data.isLeaf = false;
      _data.childs = addLeaf(data.childs);
    } else {
      _data.isLeaf = true;
    }
    return _data;
  });
};

// 获取 maxLev 级树的数据
const getDefautDatasShow = (datas, maxLev, lev = 1) => {
  datas = objToArray(datas);
  return lev > maxLev
    ? []
    : datas.map(data => {
        const _data = { ...data };
        if (_data.childs && _data.childs.length > 0) {
          _data.childs = getDefautDatasShow(data.childs, maxLev, lev + 1);
        }
        return _data;
      });
};

// 点击展开节点，添加当前节点子集数据
const getDatasShow = (datas, datashow, domid, itemMainKey = "domid") => {
  datashow = objToArray(datashow);
  return datashow.map((data, index) => {
    const _data = { ...data };
    if (_data[itemMainKey] === domid) {
      let _childs = [...datas[index].childs];
      _childs = _childs.map(c => {
        const _c = { ...c };
        _c.childs = [];
        return _c;
      });
      _data.childs = _childs;
    } else if (datas[index].childs && datas[index].childs.length > 0) {
      _data.childs = getDatasShow(
        datas[index].childs,
        _data.childs,
        domid,
        itemMainKey
      );
    }
    return _data;
  });
};

// 过滤搜索值
const filterDatas = (
  datas,
  v,
  searchKeys = ["name", "ecologyPinyinSearch"]
) => {
  datas = objToArray(datas);
  return datas
    .map(data => {
      const _data = { ...data };
      const keys = searchKeys.filter(
        key =>
          data[key] && data[key].toLowerCase().indexOf(v.toLowerCase()) >= 0
      );
      if (keys.length > 0) {
        const _childs = data.childs
          ? filterDatas([...data.childs], v, searchKeys)
          : null;
        _data.isFind = true;
        _data.isLeaf = !(_childs && _childs.length);
        _data.isParent = !_data.isLeaf;
        if (_childs && _childs.length) {
          _data.childs = _childs;
        } else {
          delete _data.childs;
        }
      } else if (data.childs && data.childs.length > 0) {
        const childs = filterDatas(data.childs, v, searchKeys);
        const _childs = childs.filter(c => c.isFind);
        if (_childs.length === 0) {
          _data.isFind = false;
        } else {
          _data.isFind = true;
          _data.childs = childs;
        }
      } else {
        _data.isFind = false;
      }
      return _data;
    })
    .filter(c => c.isFind);
};

// 点击收藏 更改收藏状态
const doFavEdit = (datas, domid, itemMainKey = "domid") => {
  datas = objToArray(datas);
  return datas.map(data => {
    const _data = { ...data };
    if (data[itemMainKey] === domid) {
      _data.fav = !_data.fav;
    } else if (data.childs && data.childs.length > 0) {
      _data.childs = doFavEdit(data.childs, domid);
    }
    return _data;
  });
};

// 删除不包含收藏节点的子集
const doNoFavDelete = datas => {
  datas = objToArray(datas);
  return datas
    .map(data => {
      const _data = { ...data };
      _data.hasChildFav = false;
      if (data.childs && data.childs.length > 0) {
        const childs = doNoFavDelete(data.childs);
        const _childs = childs.filter(c => c.fav || c.hasChildFav);
        if (_childs.length > 0) {
          _data.hasChildFav = true;
          _data.childs = _childs;
        } else {
          _data.isLeaf = true;
          _data.childs = [];
        }
      }
      return _data;
    })
    .filter(c => c.fav || c.hasChildFav);
};

class WeaLeftTree extends Component {
  static displayName = "WeaLeftTree";
  static getKeys = getKeys;
  static getAllKeys = getAllKeys;
  static addLeaf = addLeaf;
  static getDefautDatasShow = getDefautDatasShow;
  static getDatasShow = getDatasShow;
  static filterDatas = filterDatas;
  static doFavEdit = doFavEdit;
  static doNoFavDelete = doNoFavDelete;
  static defaultProps = {
    prefixCls: "wea-left-tree",
    className: "",
    cancelSelectable: true,
    datas: [],
    counts: {},
    countsType: [],
    itemMainKey: "domid",
    selectedKeys: undefined,
    expandedKeys: undefined,
    defaultExpandLevel: 2,
    asyncLoad: false,
    forceAsyn: false,
    // searchLabel: getLabel('21979', "全部类型"),
    searchValue: undefined,
    searchKeys: ["name", "ecologyPinyinSearch"],
    onlyShowFav: false,
    showCollect: false,
    // noDataLabel: getLabel('83553', "暂无数据"),
    loading: false,
    style: {},
    ops: []
  };
  constructor(props) {
    super(props);
    if (!props.vtreeMode) {
      const {
        datas,
        selectedKeys = [],
        asyncLoad,
        forceAsyn,
        defaultExpandLevel,
        itemMainKey,
        ztreeMode
      } = props;
      const _datas = addLeaf(datas);
      let expandedKeys = getAllKeys(
        getDefautDatasShow(_datas, defaultExpandLevel - 1)
      ).keys;
      let datasShow = [..._datas];
      if (asyncLoad && !ztreeMode) {
        datasShow = getDefautDatasShow(_datas, defaultExpandLevel);
        const total = getAllKeys(_datas, itemMainKey).num;
        const _total = getAllKeys(datasShow, itemMainKey).num;
        if (forceAsyn || (_total > 300 && total > 500)) {
          datasShow = getDefautDatasShow(_datas, 1);
          expandedKeys = [];
        }
      }
      this.instanceIsMounted = false;
      this.state = {
        height: 0,
        datas: _datas,
        datasShow,
        expandedKeys,
        selectedKeys,
        searchValue: ""
      };
    }
    this.getTitle = this.getTitle.bind(this);
  }
  componentDidMount() {
    this.instanceIsMounted = true;
  }
  componentWillReceiveProps(nextProps) {
    if (!nextProps.vtreeMode) {
      const {
        searchValue: _v,
        datas: _d,
        selectedKeys: _s,
        expandedKeys: _e
      } = this.state;
      const {
        searchValue,
        datas,
        selectedKeys,
        expandedKeys,
        asyncLoad,
        forceAsyn,
        defaultExpandLevel,
        ztreeMode,
        itemMainKey
      } = nextProps;
      let state = {};
      const _datas = addLeaf(datas);
      if (!isEqual(_datas, _d)) {
        let datasShow = [..._datas];
        let __e = getAllKeys(
          getDefautDatasShow(datasShow, defaultExpandLevel - 1)
        ).keys;
        if (asyncLoad && !ztreeMode) {
          datasShow = getDefautDatasShow(datasShow, defaultExpandLevel);
          const total = getAllKeys(datasShow, itemMainKey).num;
          const _total = getAllKeys(datasShow, itemMainKey).num;
          if (forceAsyn || (_total > 300 && total > 500)) {
            datasShow = getDefautDatasShow(datasShow, 1);
            __e = [];
          }
        }
        state = {
          ...state,
          datas: _datas,
          datasShow,
          ...(defaultExpandLevel ? { expandedKeys: __e } : {})
        };
      }
      if (searchValue !== undefined && searchValue !== _v) {
        state = { ...state, searchValue };
      }
      if (expandedKeys !== undefined && !isEqual(expandedKeys, _e)) {
        state = { ...state, expandedKeys };
      }
      if (selectedKeys !== undefined && !isEqual(selectedKeys, _s)) {
        state = { ...state, selectedKeys };
      }
      this.setState(state);
    }
  }
  shouldComponentUpdate(preProps, preState) {
    if (!this.props.vtreeMode) {
      const {
        datas,
        selectedKeys,
        expandedKeys,
        searchValue,
        datasShow
      } = preState;
      const {
        searchValue: _v,
        datas: _d,
        selectedKeys: _s,
        expandedKeys: _e,
        datasShow: _ds
      } = this.state;
      const { counts, countsType, loading } = preProps;
      const { counts: _c, countsType: _t, loading: _l } = this.props;

      return (
        loading !== _l ||
        searchValue !== _v ||
        !isEqual(counts, _c) ||
        !isEqual(countsType, _t) ||
        !isEqual(datas, _d) ||
        !isEqual(datasShow, _ds) ||
        !isEqual(selectedKeys, _s) ||
        !isEqual(expandedKeys, _e)
      );
    } else {
      return true;
    }
  }
  componentWillUnmount() {
    this.instanceIsMounted = false;
  }
  onExpand = (expandedKeys, target) => {
    const { onExpand, ztreeMode } = this.props;
    this.setState({ expandedKeys });
    target = target || { node: null, expanded: false };
    if (target.node) {
      target.node = ztreeMode ? target.node : target.node.props.data;
    }
    typeof onExpand === "function" && onExpand(expandedKeys, target);
  };
  onSelect = (keys, countsType) => {
    const { counts, onSelect } = this.props;
    const key = keys && keys.length > 0 ? keys[0] : "";
    this.setState({ selectedKeys: keys });
    if (typeof onSelect === "function") {
      key &&
        key.length !== 0 &&
        this.props.onSelect(
          key,
          counts ? counts[key] : "",
          countsType || "",
          keys
        );
    }
  };
  onCollect(data, e) {
    const { onCollect, onlyShowFav, itemMainKey } = this.props;
    typeof onCollect === "function" &&
      onCollect(data).then(res => {
        if (res.status === 1) {
          if (!res.hasDoFavToDatas) {
            let datasShow = doFavEdit(this.state.datasShow, data[itemMainKey]);
            if (onlyShowFav) datasShow = doNoFavDelete(datasShow);
            this.setState({ datasShow });
          }
          message.success(
            res.msg ||
              `${
                data.fav
                  ? getLabel("129248", "取消成功")
                  : getLabel("383218", "收藏成功")
              }！`
          );
        } else {
          message.warning(
            res.msg ||
              `${
                data.fav
                  ? getLabel("385902", "取消失败，请重试！")
                  : getLabel("385472", "收藏失败，请重试！")
              }`
          );
        }
      });
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  onSearchLabelClick = () => {
    const { onSearchLabelClick } = this.props;
    typeof onSearchLabelClick === "function" && onSearchLabelClick();
  };
  onSearchChange = v => {
    const {
      onSearchChange,
      defaultExpandLevel,
      asyncLoad,
      searchKeys,
      ztreeMode
    } = this.props;
    const { datas, expandedKeys } = this.state;
    const datasShow = v
      ? filterDatas(cloneDeep(datas), v, searchKeys)
      : asyncLoad && !ztreeMode
      ? getDefautDatasShow(datas, 1)
      : [...datas];
    this.setState({
      searchValue: v,
      datasShow,
      expandedKeys: v
        ? expandedKeys
        : asyncLoad && !ztreeMode
        ? []
        : getAllKeys(getDefautDatasShow(datas, defaultExpandLevel - 1)).keys
    });
    typeof onSearchChange === "function" && onSearchChange(v);
  };
  onLoadData = treeNode => {
    return new Promise(resolve => {
      setTimeout(() => {
        const { itemMainKey } = this.props;
        const { datasShow, datas } = this.state;
        const _datasShow = getDatasShow(
          datas,
          datasShow,
          treeNode.props.data[itemMainKey],
          itemMainKey
        );
        this.setState({ datasShow: _datasShow });
        resolve();
      }, 200);
    });
  };
  getTitle(data) {
    const {
      showCollect,
      itemMainKey,
      counts,
      countsType,
      ops,
      prefixCls
    } = this.props;
    const countsTypeShow = [];
    let notShowEm = 0;
    const keys = [data[itemMainKey]];
    const flowSpan = showCollect
      ? [
          <i
            title={`${
              data.fav
                ? getLabel("129753", "取消收藏")
                : getLabel("22255", "添加收藏")
            }`}
            className={`icon-coms-Collection${data.fav ? "2" : ""}`}
            onClick={this.onCollect.bind(this, data)}
          />
        ]
      : [];
    countsType &&
      countsType.forEach(c => {
        let num =
          counts && counts[data[itemMainKey]]
            ? counts[data[itemMainKey]][c.name]
              ? counts[data[itemMainKey]][c.name]
              : ""
            : "";
        if (num && num !== "0") {
          notShowEm++;
          countsTypeShow.push(c);
          if (notShowEm !== 1) {
            flowSpan.push(
              <em
                className={c.isshow ? "" : "wf-isshow"}
                style={{ display: c.isshow ? "inline" : "none" }}
              >
                {" "}
                /{" "}
              </em>
            );
          }
          flowSpan.push(
            <span
              title={c.title}
              className={c.isshow ? "" : "wf-isshow"}
              style={{
                color: c.color,
                display: c.isshow ? "inline-block" : "none"
              }}
              onClick={this.titileNumClick.bind(this, keys, c)}
            >
              {num}
            </span>
          );
        }
      });
    ops &&
      ops.length > 0 &&
      ops.forEach(op => {
        flowSpan.push(
          <div
            className={`${prefixCls}-ops`}
            key={op.key}
            onClick={() => typeof op.onClick === "function" && op.onClick(data)}
          >
            {op.show}
          </div>
        );
      });
    return (
      <Row
        onMouseEnter={this.titleHoverIn.bind(this, countsTypeShow)}
        onMouseLeave={this.titleHoverOut.bind(this, countsTypeShow)}
      >
        <Col span="24" className="titleText text-elli" title={data.name}>
          {data.name}
        </Col>
        <Col span="24" className="titleNum">
          <div>{flowSpan}</div>
        </Col>
      </Row>
    );
  }
  titileNumClick(keys, countsType, e) {
    this.onSelect(keys, countsType);
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  titleHoverIn(countsTypeShow, e) {
    $(e.target)
      .closest(".wea-tree-wrap")
      .find(".ant-tree-title .titleNum")
      .each((index, item) => {
        $(item)
          .find(".wf-isshow")
          .css({ display: "inline-block" });
        $(item)
          .find("span")
          .each((i, m) => {
            $(m).css({
              "background-color": countsTypeShow[i].color,
              color: "#fff"
            });
          });
      });
  }
  titleHoverOut(countsTypeShow, e) {
    $(e.target)
      .closest(".wea-tree-wrap")
      .find(".ant-tree-title .titleNum")
      .each((index, item) => {
        $(item)
          .find(".wf-isshow")
          .css({ display: "none" });
        $(item)
          .find("span")
          .each((i, m) => {
            $(m).css({
              color: countsTypeShow[i].color,
              "background-color": "transparent"
            });
          });
      });
  }
  renderTreeNodes(datas = [], counts = {}, countsType, lev) {
    const { itemMainKey } = this.props;
    const newDatas = [];
    datas &&
      datas.forEach(data => {
        const { childs = [] } = data;
        if (Object.keys(counts).length === 0) {
          newDatas.push(
            <TreeNode
              browserTree={true}
              key={data[itemMainKey]}
              data={data}
              isLeaf={data.isLeaf}
              title={this.getTitle(data)}
              level={lev}
            >
              {this.renderTreeNodes(childs, counts, countsType, lev + 1)}
            </TreeNode>
          );
        } else {
          const doTreeNodeRender = () => {
            newDatas.push(
              <TreeNode
                {...data}
                browserTree={true}
                key={data[itemMainKey]}
                data={data}
                isLeaf={data.isLeaf}
                title={this.getTitle(data)}
                level={lev}
              >
                {this.renderTreeNodes(childs, counts, countsType, lev + 1)}
              </TreeNode>
            );
          };
          if (
            counts[data[itemMainKey]] &&
            (typeof counts[data[itemMainKey]].flowAll === "string" ||
              (counts[data[itemMainKey]].flowAll &&
                counts[data[itemMainKey]].flowAll !== "0"))
          ) {
            // 流程
            doTreeNodeRender();
          } else if (
            counts[data[itemMainKey]] &&
            counts[data[itemMainKey]].allNum !== undefined
          ) {
            // 知识，这需求设计真是坑了
            doTreeNodeRender();
          }
        }
      });
    return newDatas;
  }
  render() {
    if (this.props.vtreeMode) {
      return <WeaTreeTest {...this.props} />;
    }
    const {
      prefixCls,
      className,
      counts,
      countsType,
      asyncLoad,
      asyncTree,
      ztreeMode,
      searchLabel,
      noDataLabel,
      loading,
      style
    } = this.props;
    const { datasShow, expandedKeys, selectedKeys, searchValue } = this.state;
    const props = {
      ...(asyncLoad && !ztreeMode ? { loadData: this.onLoadData } : {}),
      ...this.props,
      // 为实现异步树做展开受控处理 - 知识组
      expandedKeys: asyncTree ? this.props.expandedKeys : expandedKeys
    };

    return (
      <div className={`${prefixCls} ${className}`} style={style}>
        <Spin spinning={loading}>
          <div className={`${prefixCls}-search`}>
            <span
              className={`${prefixCls}-search-label`}
              onClick={this.onSearchLabelClick}
            >
              {searchLabel !== void 0
                ? searchLabel
                : getLabel("21979", "全部类型")}
            </span>
            <WeaInputSearch
              value={searchValue}
              onSearchChange={this.onSearchChange}
            />
          </div>
          <div className={`${prefixCls}-scroll`}>
            <WeaNewScroll height="100%">
              {datasShow.length === 0 ? (
                <p className={`${prefixCls}-noData`}>
                  <i className="icon-coms-Invalid" />
                  {noDataLabel !== void 0
                    ? noDataLabel
                    : getLabel("83553", "暂无数据")}
                </p>
              ) : null}
              {
                <Tree
                  autoExpandParent={false}
                  openTransitionName=""
                  showLine
                  {...props}
                  prefixCls="ant-tree"
                  className={`${prefixCls}-antd ${className}`}
                  selectedKeys={selectedKeys}
                  onExpand={this.onExpand}
                  onSelect={this.onSelect}
                  treeData={datasShow}
                  ztreeMode={ztreeMode}
                  getTitle={this.getTitle.bind(this)}
                  browserTree={true}
                >
                  {this.renderTreeNodes(datasShow, counts, countsType, 0)}
                </Tree>
              }
            </WeaNewScroll>
          </div>
        </Spin>
      </div>
    );
  }
}

const Com = middleware(WeaLeftTree, "WeaLeftTree");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-left-tree/index.js